// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
import { FailureAction } from "../FailureAction";
export class FetchUserPhotoSucceededAction extends TypedAction(ActionType.FetchUserPhotoSucceededAction) {
    /** Disable logging to reduce logs */ isLoggingEnabled() {
        return false;
    }
    constructor(userId, userPhoto, status){
        super(), this.userId = userId, this.userPhoto = userPhoto, this.status = status;
    }
}
export class FetchUserPhotoFailedAction extends FailureAction {
    /** Disable logging, this is expected & common case and gracefully handled */ isLoggingEnabled() {
        return false;
    }
    constructor(userId, response, textStatus, errorThrown, status){
        super(ActionType.FetchUserPhotoFailedAction, response, textStatus, errorThrown), this.userId = userId, this.status = status;
    }
}
export class FetchUsersByKeywordAction extends TypedAction(ActionType.FetchUsersByKeywordAction) {
    constructor(keyword){
        super(), this.keyword = keyword;
    }
}
export class FetchUsersByKeywordSucceededAction extends TypedAction(ActionType.FetchUsersByKeywordSucceededAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            userCount: this.users.length.toString()
        };
    }
    constructor(keyword, users){
        super(), this.keyword = keyword, this.users = users;
    }
}
export class FetchUsersByKeywordFailedAction extends FailureAction {
    constructor(keyword, response, textStatus, errorThrown){
        super(ActionType.FetchUsersByKeywordFailedAction, response, textStatus, errorThrown), this.keyword = keyword;
    }
}
export class FetchUserSettingsSucceededAction extends TypedAction(ActionType.FetchUserSettingsSucceededAction) {
    constructor(userSettings){
        super(), this.userSettings = userSettings;
    }
}
